<template>
  <div class="notification-pane">
    <b-tabs content-class="mt-3">
      <b-tab active>
        <template #title>
          Open Cases <span v-if="open > 0" class="numberCases">{{ open }}</span>
        </template>
        <table class="table table-striped">
          <thead class="thead-light">
            <tr>
              <th scope="col">Location</th>
              <th scope="col">Emergency Type</th>
              <th scope="col">Resolve</th>
              <th scope="col">Notify</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(notification, index) in notifications" :key="index" v-if="showNotification(notification.hidden) && notification.resolved === false">
              <td>
                {{ notification.tile }}
                <b-button class="tile-highlight" :id="'highlight' + notification.id" @click="toggleHighlight(notification.tile, notification.id)">
                  Show
                </b-button>
              </td>
              <td>
                {{ notification.category }}
                <i class="fa fa-info-circle" @click="showInfo(index)" />
              </td>
              <td>
                <span v-if="notification.resolved === false">
                  <button @click="resolve(index)">Resolve</button>
                </span>
              </td>
              <td>
                <b-button v-b-toggle :href="'#' + notification.id" @click.prevent>Notify</b-button>
                <b-collapse :id="notification.id">
                  <b-form-group label="Team Members:" v-slot="{ ariaDescribedby }">
                    <b-form-checkbox-group
                      id="groupMembers"
                      v-model="selected"
                      :aria-describedby="ariaDescribedby"
                    >
                      <b-form-checkbox v-for="(user, usrIndex) in group" :key="usrIndex" :value="user.id + '-' + user.name">{{ user.name }} - {{ user.role }}</b-form-checkbox>
                    </b-form-checkbox-group>
                  </b-form-group>
                  <button @click="notify(index)">Push Notification</button>
                </b-collapse>
              </td>
            </tr>
          </tbody>
        </table>
      </b-tab>
      <b-tab>
        <template #title>
          Closed Cases <span v-if="closed > 0" class="numberCases">{{ closed }}</span>
        </template>
        <table class="table table-striped">
          <thead class="thead-light">
            <tr>
              <th scope="col">Location</th>
              <th scope="col">Emergency Type</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(notification, index) in notifications" :key="index" v-if="notification.hidden !== true && notification.resolved === true">
              <td>
                {{ notification.tile }}
              </td>
              <td>
                {{ notification.category }}
                <i class="fa fa-info-circle" @click="showInfo(index)" />
              </td>
            </tr>
          </tbody>
        </table>
      </b-tab>
      <b-tab title="Data Scientist" v-if="role === 'Data Scientist' || role === 'unassigned'">
        <table class="table table-striped">
          <thead class="thead-light">
            <tr>
              <th scope="col" style="text-align: center;">Caselet Type</th>
              <th scope="col" style="text-align: center;">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="caselet in caseletList">
              <td style="text-align: center;">{{ caselet.name }}</td>
              <td style="text-align: center;">
                <b-button v-if="!caselet.analyzed" @click="analyze(caselet.name)">Analyze</b-button>
                <span v-else>Analyzed</span>
              </td>
            </tr>
          </tbody>
        </table>
        <!--<table class="table table-striped">
          <thead class="thead-light">
            <tr>
              <th scope="col" style="text-align: center;">Location</th>
              <th scope="col" v-for="(caselet, index) in cases" :key="index" style="text-align: center;">
                {{ caselet.name }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(tile, index) in forecast" :key="index">
              <td style="text-align: center;">{{ index }}</td>
              <td :class="probability.percentage" v-for="(probability, caseIndex) in tile" :key="caseIndex" style="text-align: center;">
                {{ probability.percentage }}
              </td>
            </tr>
          </tbody>
        </table>-->
      </b-tab>
    </b-tabs>
    <b-modal id="caseletModal" :title="caseletInfo.category" hide-footer>
      <div class="modal-body">
        <p>{{ caseletInfo.detail }}</p>
        <p>Departments Needed:</p>
        <ul><li v-for="(dpt, index) in caseletInfo.departments" :key="index">{{ dpt.name }}: {{ dpt.cost }} actions</li></ul>
        <p>Location: {{ caseletInfo.tile }}</p>
        <p>Status: <span v-if="caseletInfo.resolved">Closed</span><span v-else>Open</span></p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" @click="closeModal">Close</button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  layout: 'basepcs',

  props: {
    notifications: Array,
    forecast: Object,
    caseletList: Array,
  },

  data: () => ({
    title: window.config.appName,
    groupID: '',
    caseletInfo: {},
    cases: [],
    selected: [],
  }),

  computed: {
    ...mapState({
      user: state => state.auth.user,
      role: state => state.group.role.name,
      dispatch: state => state.gameboard.rules.dispatch,
      open: function() {
        let val = 0
        this.notifications.forEach(caselet => {
          if (caselet.hidden.length > 0 && caselet.resolved === false) {
            val += 1
          }
        })
        return val
      },
      closed: function() {
        let val = 0
        this.notifications.forEach(caselet => {
          if (caselet.hidden.length > 0 && caselet.resolved === true) {
            val += 1
          }
        })
        return val
      },
      group: function() {
        let data = []
        this.$store.state.chat.conversations.forEach(user => {
          if (user.id >= 0) {
            data.push(user)
          }
        })
        return data
      },
    }),
    ...mapGetters({
      classId: 'auth/classId',
    }),
  },

  created() {
    // this.cases = this.forecast[Object.keys(this.forecast)[0]]
    axios.post('/api/getGroup', {
      params: {
        pcs: localStorage.getItem('pcs'),
        classId: this.classId
      },
    })
      .then(response => {
        this.groupID = response.data
      })
  },

  methods: {
    ...mapActions({}),

    showNotification(hidden) {
      let found = false
      hidden.forEach(id => {
        if (id === this.user.id) {
          found = true
        }
      })
      return found
    },

    reverse(array) {
      return array.slice().reverse()
    },

    resolve(index) {
      this.$emit('resolve', index)
    },

    notify(index) {
      this.$emit('pushNotification', { 'index': index, 'users': this.selected })
      this.selected = []
    },

    analyze(type) {
      let tokens = this.$store.state.gameboard.tokens.players
      tokens.forEach(player => {
        if (player.type === 'analysis') {
          if (player.actions.available >= player.actions.cost) {
            this.caseletList.forEach(caselet => {
              if (caselet.name === type) {
                caselet.analyzed = true
              }
            })
            this.$emit('analyze', { 'type': type, 'cost': player.actions.cost })
          } else {
            alert('not enough moves')
          }
        }
      })
    },

    toggleHighlight(tile, id) {
      let show = null
      if (document.getElementById('highlight' + id).innerText === 'Show') {
        show = true
        document.getElementById('highlight' + id).innerText = 'Hide'
      } else {
        show = false
        document.getElementById('highlight' + id).innerText = 'Show'
      }
      let data = [tile, show]
      this.$emit('highlightTile', data)
    },

    showInfo(index) {
      this.caseletInfo = this.notifications[index]
      this.$bvModal.show('caseletModal')
    },

    closeModal() {
      this.caseletInfo = {}
      this.$bvModal.hide('caseletModal')
    },
  },
  watch: {},
}
</script>

<style scoped lang="scss">
.Low {
  background-color: none;
}

.Medium {
  background-color: darkorange;
}

.High {
  background-color: orangered;
}

.numberCases {
  width: auto;
  background: aqua;
  padding: 1px 5px;
  border-radius: 9px;
  vertical-align: super;
}

hr {
  margin: 0;
}
.right {
  float: right;
}

.tile-highlight{
  padding: 5px;
  height: fit-content;
  font-size: 10px;
}

.notification-pane{
  width: inherit;
  max-height: 100%;
  overflow-y: auto;
  .header{
    font-weight: bold;
    text-align: center;
  }
  .notifications{
    overflow-y: auto;
    .notification{
    }
  }
}

</style>
